/* Crystal N Cuts — header menus open on hover (desktop mouse), close on leave / Esc.
   Click and keyboard still work through Dawn's own header-menu element. */
(function () {
  if (window.__cncHeader) return;
  window.__cncHeader = true;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!fine || !fine.matches) return;

  function bind(root) {
    (root || document).querySelectorAll('.cnc-head .header__inline-menu header-menu > details').forEach(function (d) {
      if (d.__cnc) return;
      d.__cnc = true;
      var li = d.closest('li') || d, t;
      var summary = d.querySelector('summary');
      function open() {
        clearTimeout(t);
        document.querySelectorAll('.cnc-head .header__inline-menu details[open]').forEach(function (o) {
          if (o !== d) { o.removeAttribute('open'); var s = o.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false'); }
        });
        if (!d.hasAttribute('open')) { d.setAttribute('open', ''); if (summary) summary.setAttribute('aria-expanded', 'true'); }
      }
      function close() {
        t = setTimeout(function () {
          d.removeAttribute('open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, 160);
      }
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.cnc-head .header__inline-menu details[open]').forEach(function (o) { o.removeAttribute('open'); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
